<script setup>

import MovingTooltip from "@/components/common/other/MovingTooltip";

const props = defineProps({

  modelValue: {}
})

function addressFormatting(type) {

  let address = [];

  address.push(props.modelValue[type].addressLine1);
  address.push(props.modelValue[type].addressLine2);
  address.push(props.modelValue[type].addressLine3);
  address.push(props.modelValue[type].addressLine4);
  address.push(props.modelValue[type].postCode);
  address.push(props.modelValue[type].country);

  return address

}

function addressDataCheck(type) {

  for(let item in props.modelValue[type]) {

    return props.modelValue[type][item]

  }

}

</script>

<template class="cmp-address-and-contact">
  <div class="cmp-address-and-contact_two-flex-section">
    <div class="cmp-address-and-contact_area-width"><span class="label">Shipper Details</span>
      <div class="cmp-address-and-contact_contact-card">
        <div class="cmp-address-and-contact_contact-icon"><i class="fa-thin fa-circle-user"></i>
        </div>
        <div class="cmp-address-and-contact_contact-text">
          <div class="cmp-address-and-contact_contact-name"
               :class="!modelValue.shipperContact.name ? 'global-no-data-placeholder' : ''">
            {{ modelValue.shipperContact.name || 'No Contact Name' }}
          </div>
          <div class="cmp-address-and-contact_contact-position"
               :class="!modelValue.shipperContact.position ? 'global-no-data-placeholder' : ''">
            {{ modelValue.shipperContact.position || 'Position Not Provided' }}
          </div>
          <div class="global-center-items">
            <i class="fa-solid fa-square-phone cmp-address-and-contact_contact-tel-icon" style="font-size: 13px;"></i>
            <span class="cmp-address-and-contact_contact-tel"
                  :class="!modelValue.shipperContact.telephone ? 'global-no-data-placeholder' : ''">
                  {{ modelValue.shipperContact.telephone || 'Number Not Provided' }}
            </span>
          </div>
          <div class="global-center-items">
            <i class="fa-solid fa-envelope" style="color:#228491; font-size: 12px; line-height: normal;"></i>
            <span style="margin-left: 5px; color: #808080; font-size: 11px;"
                  :class="!modelValue.shipperContact.email ? 'global-no-data-placeholder' : ''">
                {{ modelValue.shipperContact.email || 'Email Not Provided'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="cmp-address-and-contact_contact consignee">
      <div><span class="label">Consignee Details</span>
        <div class="cmp-address-and-contact_contact-card consignee">
          <div class="cmp-address-and-contact_contact-icon"><i class="fa-thin fa-circle-user"></i></div>
          <div class="cmp-address-and-contact_contact-text">
            <div class="cmp-address-and-contact_contact-name"
                 :class="!modelValue.consigneeContact.name ? 'global-no-data-placeholder' : ''">
              {{ modelValue.consigneeContact.name || 'No Contact Name' }}
            </div>
            <div class="cmp-address-and-contact_contact-position"
                 :class="!modelValue.consigneeContact.position ? 'global-no-data-placeholder' : ''">
              {{ modelValue.consigneeContact.position || 'Position Not Provided' }}
            </div>
            <div class="global-center-items">
              <i class="fa-solid fa-square-phone cmp-address-and-contact_contact-tel-icon" style="font-size: 13px;"></i>
              <span class="cmp-address-and-contact_contact-tel"
                    :class="!modelValue.consigneeContact.telephone ? 'global-no-data-placeholder' : ''">
                  {{ modelValue.consigneeContact.telephone || 'Number Not Provided' }}
              </span>
            </div>
            <div class="global-center-items">
              <i class="fa-solid fa-envelope" style="color:#228491; font-size: 12px; line-height: normal;"></i>
              <span style="margin-left: 5px; color: #808080; font-size: 11px;"
                    :class="!modelValue.consigneeContact.email ? 'global-no-data-placeholder' : ''">
                {{ modelValue.consigneeContact.email || 'Email Not Provided'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cmp-address-and-contact_two-flex-section">
    <div class="cmp-address-and-contact_area-width">
      <div class="cmp-address-and-contact_contact-card cmp-address-and-contact_address">
        <div class="cmp-address-and-contact_address-text">
          <div style="position: absolute; top: 70px; left: 100px;">
            <div v-if="!addressDataCheck('shipperAddress')" class="global-no-data-placeholder global-center-items">
              <i class="fa-regular fa-circle-exclamation cmp-address-and-contact_contact-tel-icon"
                 style="font-size: 13px; margin-right: 5px; color: #d68127;"></i>No Address Information
            </div>
          </div>
          <div class="cmp-address-and-contact_address-company">{{ modelValue.shipperName }}</div>
          <div v-for="(addressLine, index) in addressFormatting('shipperAddress') ">
            <MovingTooltip :icon="false">
              <template #content>
<!--                <div>-->
<!--                  <div class="label">AddressLine 1</div><span>{{modelValue.shipperAddress.addressLine1}}</span>-->
<!--                </div>-->
                <div v-for="each in addressFormatting('shipperAddress') ">{{ each }}</div>
              </template>
              <div>{{ addressLine }}</div>
            </MovingTooltip>
          </div>
        </div>
        <div class="cmp-address-and-contact_address-text cmp-address-and-contact_card-footer">
          <div><i class="fa-solid fa-square-phone cmp-address-and-contact_contact-tel-icon" style="font-size: 16px;"></i>
            <span :class="!modelValue.shipperAddress.telephone ? 'global-no-data-placeholder' : ''"
                  class="cmp-address-and-contact_address-tel">{{ modelValue.shipperAddress.telephone || 'No Number Provided' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="cmp-address-and-contact_contact-card cmp-address-and-contact_address">
        <div class="cmp-address-and-contact_address-text">
          <div style="position: absolute; top: 70px; left: 100px;">
            <div  v-if="!addressDataCheck('consigneeAddress')" class="global-no-data-placeholder global-center-items">
              <i class="fa-regular fa-circle-exclamation cmp-address-and-contact_contact-tel-icon"
                 style="font-size: 13px; margin-right: 5px; color: #d68127;"></i>No Address Information
            </div>
          </div>
          <div class="cmp-address-and-contact_address-company">{{ modelValue.consigneeName }}</div>
          <div v-for="(addressLine, index) in addressFormatting('consigneeAddress') ">
            <MovingTooltip :icon="false">
              <template #content>
                <div v-for="each in addressFormatting('consigneeAddress') ">{{ each }}</div>
              </template>
              <div>{{ addressLine }}</div>
            </MovingTooltip>
          </div>
        </div>
        <div class="cmp-address-and-contact_address-text cmp-address-and-contact_card-footer">
          <div><i class="fa-solid fa-square-phone cmp-address-and-contact_contact-tel-icon" style="font-size: 16px;"></i>
            <span :class="!modelValue.consigneeAddress.telephone ? 'global-no-data-placeholder' : ''"
                  class="cmp-address-and-contact_address-tel">{{ modelValue.consigneeAddress.telephone || 'No Number Provided' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.cmp-address-and-contact {

  &_two-flex-section {
    display: flex;
    margin-left: 50px;
  }

  &_area-width {
    width: 50%;
  }

  &_contact-card {
    position: relative;
    margin-top: 10px;
    width: 340px;
    height: 80px;
    border: 1px solid var(--border-color);
    border-radius: var(--rounded-corners);
    display: flex;
    gap: 40px;
    //background-image: linear-gradient(240deg, #f4f4f4, #ffffff);
    background: #fff;
  }

  &_address {
    height: 150px;
    overflow: hidden;
  }

  &_address-company {
    font-weight: bold;
    font-size: 12px;
    color: #131313;
  }

  &_contact-icon {
    display: flex;
    align-items: center;
    color: #0084c3;
    opacity: 0.6;
    font-size: 40px;
    padding-left: 20px;
    gap: 50px
  }

  &_contact-text {
    padding-top: 5px;
    color: #232323;
  }

  &_contact-name {
    font-size: 12px;
    font-weight: bold;
  }

  &_contact-position {
    font-size: 10px;
    margin-bottom: 10px;
    color: #777676;
  }

  &_contact-tel {
    font-size: 11px;
    font-weight: bold;
    margin-left: 5px;
  }

  &_address-tel {
    margin-left: 5px;
    color: #2d2d2d;
    font-weight: bold;
  }

  &_contact-tel-icon {
    color: #224e91;
  }

  &_address-text {
    margin: 10px 0 0 20px;
    color: #808080;
    font-size: 11px;
  }

  &_address-text div {
    margin-bottom: 2px;
  }

  &_card-footer {
    position: absolute;
    bottom: 0;
    height: 30px;
    border-radius: 4px;
  }

  &_card-footer div {
    display: flex;
    align-items: center;
  }


}

</style>
